import { Injectable, inject } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { BehaviorSubject, Observable, take } from 'rxjs';
import { GET_POLICIES } from '../../_shared/_graphql/policies';
import { IPolicy, PolicyType } from '../_models/policy.model';

@Injectable({
  providedIn: 'root'
})
export class PolicyService {
  private readonly apolloService = inject(Apollo);

  public policies$!: Observable<Array<IPolicy>>;

  private readonly _policies: BehaviorSubject<Array<IPolicy>>;

  constructor() {
    this._policies = new BehaviorSubject<Array<IPolicy>>([]);
    this.policies$ = this._policies.asObservable();
  }

  public loadPolicies(): void {
    this.getPolicies()
      .pipe(take(1))
      .subscribe((result: any) => {
        const policies = PolicyService.getPoliciesFromQuery(result);
        this._policies.next(policies);
      });
  }

  private getPolicies(): Observable<any> {
    return this.apolloService
      .watchQuery({
        query: GET_POLICIES
      })
      .valueChanges.pipe(take(1));
  }

  private static getPoliciesFromQuery(result: any): Array<IPolicy> {
    const policyResponse = result?.data?.shop;
    let policies = new Array<IPolicy>();
    if (policyResponse) {
      if (policyResponse.privacyPolicy) {
        const privacyPolicy: IPolicy = {
          html: policyResponse?.privacyPolicy?.body,
          policyType: PolicyType.PRIVACY
        }
        policies.push(privacyPolicy);
      }
      if (policyResponse.shippingPolicy) {
        const shippingPolicy: IPolicy = {
          html: policyResponse?.shippingPolicy?.body,
          policyType: PolicyType.SHIPPING
        }
        policies.push(shippingPolicy);
      }
      if (policyResponse.termsOfService) {
        const termsOfService: IPolicy = {
          html: policyResponse?.termsOfService?.body,
          policyType: PolicyType.TERMS_OF_SERVICE
        }
        policies.push(termsOfService);
      }
      if (policyResponse.refundPolicy) {
        const refundPolicy: IPolicy = {
          html: policyResponse?.refundPolicy?.body,
          policyType: PolicyType.REFUND
        }
        policies.push(refundPolicy);
      }
    }

    return policies;
  }
}
